import { animate, style, transition, trigger } from '@angular/animations';

export const FadeInOut = [
  trigger('fadeInOut', [
    transition(':enter', [style({ opacity: 0 }), animate(200)]),
    transition(':leave', animate(200, style({ opacity: 0 }))),
  ]),
];

export const fadeIn = [
  trigger('fadeIn', [transition(':enter', [style({ opacity: 0 }), animate('400ms 100ms ease-out')])]),
];
